import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a632dcec&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a632dcec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a632dcec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a632dcec')) {
      api.createRecord('a632dcec', component.options)
    } else {
      api.reload('a632dcec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a632dcec&scoped=true&", function () {
      api.rerender('a632dcec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/WechatTip/index.vue"
export default component.exports